import Image from "next/image";
import Link from "next/link";
import { formatDate } from "@/lib/utils";
import { PostOrPage } from "@tryghost/content-api";

const BlogPostCard = ({ post }: { post: PostOrPage }) => (
  <Link href="/blog/[slug]" as={`/blog/${post.slug}`}>
    <div className="group relative isolate mx-auto flex max-h-[350px] max-w-[350px] flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-6 pb-7 pt-80 outline outline-gray-50 hover:outline-gray-100 md:max-w-none">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0">
          <Image
            className="size-full object-cover transition-transform duration-300 group-hover:scale-105"
            src={post.feature_image || ""}
            alt={post.slug.replace("-", " ")}
            width={300}
            height={300}
            draggable={false}
          />
        </div>
      </div>

      {/* mask */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />
      <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />

      <div className="space-y-2">
        <div className="w-fit rounded-full bg-white/10 px-2 py-0.5 text-center text-xs text-gray-300 backdrop-blur-sm">
          {post.tags?.[0]?.name || ""}
        </div>
        <h3 className="text-lg/6 font-semibold text-white">
          <span className="absolute inset-0" />
          {post.title}
        </h3>
        <time dateTime={post.published_at || ""} className="text-[11px] text-white/70">
          {formatDate(post.published_at || "")}
        </time>
      </div>
    </div>
  </Link>
);

export default BlogPostCard;
